import { NavLink } from "react-router-dom";
import "../Navbar.css";
import NavBar from "./NavBar";
//import css
const Header = () => {

  return (
    <header id="header" className=" header sticky ">
      <div className="compani">
        <NavLink to="/" className={(navInfo) => (navInfo.isActive ? "navLogInfo" : "")}>
          <span className="material-symbols-outlined manuIcone"> menu </span>
          <span>মহাপ্রভু ফার্নিচার</span>
        </NavLink>
        <span
          name="openManuIcone2"
          className="material-symbols-outlined forToggleOpen openManuIcone2 manuIcone2 openManuIcone2"
        >
          {" "}
          menu{" "}
        </span>
        <span
          name="closeManuIcone2"
          className="material-symbols-outlined forToggleClose closeManuIcone2 manuIcone2 closeManuIcone2"
        >
          {" "}
          close{" "}
        </span>
      </div>
      <NavBar className="navbar" />
    </header>
  );
};
export default Header;
